// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
    background-color: transparent;
    min-height: 100vh;
    height: auto;
    display: flex;
    margin: 0;
    width: 100%;
    padding: 2rem;
    padding-top: 5rem;
    padding-bottom: 3rem;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    /* Smooth momentum scrolling on iOS */
}

.auth-header-icons {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    display: flex;
    gap: 1rem;
    z-index: 100;
}

.auth-container {
    top: 3rem;
    width: 90%;
    max-width: 500px;
    height: 90%;
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 50px;
    padding: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: auto;
}

/* 使用伪元素创建带圆角的渐变边框 */
.auth-container::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.auth-top-star,
.auth-bottom-star {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.75rem 0;
}

.star-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.auth-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    width: 100%;
}

.auth-main-title {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 2rem;
    font-weight: 600;
    color: rgba(213, 190, 155, 1);
    margin: 0 0 0.5rem 0;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-shadow: 0 0 30px rgba(213, 190, 155, 1);
}

.auth-subtitle {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.95rem;
    color: rgba(213, 190, 155, 1);
    margin: 0 0 2rem 0;
    letter-spacing: 0.05em;
    font-weight: 400;
}

.auth-form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    width: 100%;
}

.form-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 0.5rem;
    position: relative;
}

.form-label {
    font-family: 'Urbanist-Regular';
    font-size: 1.2rem;
    color: rgba(213, 190, 155, 1);

    text-align: left;
    text-transform: capitalize;
}

.password-input-wrapper {
    position: relative;
    width: 100%;
}

.email-input-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    gap: 0.5rem;
}

.email-input {
    flex: 1 1;
}

.send-code-btn {
    padding: 0.9rem 1.2rem;
    background-color: rgba(213, 190, 155, 0.15);
    border: 1px solid rgba(213, 190, 155, 0.5);
    border-radius: 1000px;
    color: rgba(213, 190, 155, 1);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 0.05em;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    flex-shrink: 0;
}

.send-code-btn:hover:not(:disabled) {
    background-color: rgba(213, 190, 155, 0.25);
    border-color: rgba(213, 190, 155, 0.7);
}

.send-code-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.form-input {
    width: 100%;
    padding: 0.9rem 1rem;
    background-color: rgba(208, 181, 137, 0.35);
    border: none;
    border-radius: 1000px;
    color: rgba(213, 190, 155, 1);
    font-family: 'Urbanist-Regular';
    font-size: 1rem;
    letter-spacing: 0.05em;
    transition: all 0.3s ease;
    position: relative;
    isolation: isolate;
    box-sizing: border-box;
}

.password-input {
    padding-right: 3rem;
}

/* 使用伪元素创建输入框的渐变边框（0.5px 边框，带圆角） */
.form-input::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 1000px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.form-input::placeholder {
    color: rgba(213, 190, 155, 1);
}

.form-input:focus {
    outline: none;
}

/* Date and Time input specific fixes for iOS */
input[type="date"].form-input,
input[type="time"].form-input {
    appearance: none;
    min-height: 48px;
    max-width: 100%;
}

input[type="date"].form-input::-webkit-calendar-picker-indicator,
input[type="time"].form-input::-webkit-calendar-picker-indicator {
    filter: invert(0.8) sepia(1) saturate(2) hue-rotate(10deg);
    cursor: pointer;
}

.password-toggle {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: rgba(213, 190, 155, 1);
    cursor: pointer;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
}

.password-toggle:hover {
    color: rgba(213, 190, 155, 1);
}

.password-toggle svg {
    width: 20px;
    height: 20px;
}

.auth-submit-btn,
.auth-social-btn {
    width: 100%;
    padding: 1rem 2rem;
    background-color: #000000;
    border: none;
    border-radius: 1000px;
    color: rgba(213, 190, 155, 1);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    position: relative;
    isolation: isolate;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.auth-social-btn {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    flex: 1 1;
    white-space: nowrap;
}

.auth-social-buttons {
    display: flex;
    gap: 0.75rem;
    width: 100%;
}

.auth-social-buttons-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    width: 100%;
}

.auth-social-btn-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #000000;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
    position: relative;
    isolation: isolate;
    color: rgba(213, 190, 155, 1);
}

/* 使用伪元素创建圆形按钮的渐变边框 */
.auth-social-btn-circle::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.auth-social-btn-circle:hover {
    transform: scale(1.1);
    background-color: rgba(0, 0, 0, 0.8);
}

.auth-social-btn-circle:active {
    transform: scale(0.95);
}

.auth-social-btn-circle svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.auth-or-text {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.9rem;
    color: rgba(213, 190, 155, 1);
    text-align: center;
    margin-bottom: 1rem;
}

.form-checkbox-group {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    width: 100%;
    margin: 1rem 0;
}

.auth-checkbox {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    border-radius: 100%;
    cursor: pointer;
    accent-color: rgba(213, 190, 155, 1);
    flex-shrink: 0;
}

.auth-checkbox-label {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    color: rgba(213, 190, 155, 1);
    line-height: 1.5;
    cursor: pointer;
    flex: 1 1;
}

.auth-link-inline {
    background: none;
    border: none;
    color: rgba(213, 190, 155, 1);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.85rem;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
    margin: 0;
    text-transform: uppercase;
}

.auth-link-inline:hover {
    color: rgba(213, 190, 155, 0.8);
}

.auth-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 2rem
}

.divider-line {
    flex: 1 1;
    height: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
}

.divider-star {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;
}

/* 使用伪元素创建按钮的渐变边框 */
.auth-submit-btn::before,
.auth-social-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 1000px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.auth-submit-btn:hover,
.auth-social-btn:hover {
    background-color: rgba(0, 0, 0, 0.8);
    transform: translateY(-2px);
}

.auth-submit-btn:active,
.auth-social-btn:active {
    transform: translateY(0);
}

.auth-social-btn svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.auth-footer-link {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.9rem;
    color: rgba(213, 190, 155, 1);
    margin: 0;
    text-align: center;
}

.auth-link {
    background: none;
    border: none;
    color: rgba(213, 190, 155, 1);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.9rem;
    letter-spacing: 0.05em;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 0;
    margin-left: 0.5rem;
    text-transform: capitalize;
}

.auth-link:hover {
    color: rgba(213, 190, 155, 1);
    text-decoration: underline;
}

.auth-icon-btn {
    background-color: transparent;
    width: 50px;
    height: 50px;
    border: none;
    /* Add this back */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
    position: relative;
    isolation: isolate;
    color: rgba(213, 190, 155, 1);
}

/* Hide the border pseudo-element */
.auth-icon-btn::before {
    display: none;
}

.auth-icon-btn:hover {
    transform: scale(1.1);
    background-color: transparent;
    /* Remove hover background */
    color: rgba(213, 190, 155, 0.8);
    /* Optional: add subtle color change on hover */
}

.auth-icon-btn:active {
    transform: scale(0.95);
}

.policy-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(5, 3, 14, 0.85);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    z-index: 200;
    overflow-y: auto;
}

.policy-modal {
    position: relative;
    width: min(960px, 100%);
    max-height: calc(100vh - 4rem);
    background: rgba(0, 0, 0, 0.85);
    border-radius: 36px;
    padding: 2.5rem 2rem;
    color: rgba(213, 190, 155, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.policy-modal::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 36px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: 0;
}

.policy-modal>* {
    position: relative;
    z-index: 1;
}

.policy-close-btn {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.6);
    color: rgba(213, 190, 155, 1);
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.policy-close-btn:hover {
    background: rgba(213, 190, 155, 0.15);
}

.policy-label {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    text-transform: uppercase;
    letter-spacing: 0.3em;
    font-size: 0.8rem;
    color: rgba(213, 190, 155, 0.8);
    margin-bottom: 1rem;
}

.policy-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0.5rem;
}

.policy-star {
    font-size: 1.2rem;
    color: rgba(213, 190, 155, 1);
}

.policy-title {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1.8rem;
    letter-spacing: 0.25em;
    margin: 0;
}

.policy-subtitle {
    text-align: center;
    margin: 0.5rem 0 1.5rem 0;
    font-size: 0.9rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
}

.policy-scroll {
    max-height: 55vh;
    overflow-y: auto;
    padding-right: 1rem;
    -webkit-overflow-scrolling: touch;
}

.policy-section {
    margin-bottom: 1.5rem;
}

.policy-section h3 {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1.1rem;
    letter-spacing: 0.15em;
    margin-bottom: 0.5rem;
}

.policy-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    font-size: 0.9rem;
    line-height: 1.6;
    letter-spacing: 0.05em;
}

.policy-divider {
    text-align: center;
    color: rgba(213, 190, 155, 0.6);
    margin-top: 1rem;
}

.policy-scroll::-webkit-scrollbar {
    width: 6px;
}

.policy-scroll::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 999px;
}

.policy-scroll::-webkit-scrollbar-thumb {
    background: rgba(213, 190, 155, 0.5);
    border-radius: 999px;
}

@media (max-width: 768px) {
    .auth-page {
        padding: 1rem;
        /* align-items 由 margin: auto 处理 */
        padding-top: 4rem;
        padding-bottom: 3rem;
        overflow-y: auto;
    }

    .auth-container {
        padding: 2rem 1.5rem;
        margin: 0 auto;
    }

    .auth-main-title {
        font-size: 1.8rem;
    }

    .auth-subtitle {
        font-size: 0.9rem;
        margin-bottom: 1.5rem;
    }

    .auth-submit-btn,
    .auth-social-btn {
        padding: 0.9rem 1.5rem;
        font-size: 0.9rem;
    }

    .auth-top-star,
    .auth-bottom-star {
        padding: 0.5rem 0;
    }

    .auth-form {
        gap: 1rem;
    }

    .form-group {
        gap: 0.4rem;
    }
}

@media (max-width: 480px) {
    .auth-page {
        padding: 0.5rem;
        padding-top: 3.5rem;
        padding-bottom: 2.5rem;
        overflow-y: auto;
    }

    .auth-container {
        padding: 1.5rem 1rem;
        border-radius: 30px;
    }

    .auth-container::before {
        border-radius: 30px;
    }

    .auth-main-title {
        font-size: 1.4rem;
        margin-bottom: 0.25rem;
    }

    .auth-subtitle {
        font-size: 0.8rem;
        margin-bottom: 1rem;
    }

    .auth-form {
        gap: 0.8rem;
    }

    .form-input {
        padding: 0.75rem 0.85rem;
        font-size: 0.9rem;
    }

    .form-label {
        font-size: 1rem;
    }

    .auth-submit-btn,
    .auth-social-btn {
        padding: 0.75rem 1rem;
        font-size: 0.85rem;
    }

    .form-checkbox-group {
        margin: 0.6rem 0;
        gap: 0.5rem;
    }

    .auth-checkbox-label {
        font-size: 0.75rem;
        line-height: 1.4;
    }

    .auth-link-inline {
        font-size: 0.75rem;
    }

    .auth-divider {
        margin: 0.8rem 0;
    }

    .auth-or-text {
        font-size: 0.8rem;
        margin-bottom: 0.8rem;
    }

    .auth-social-buttons-circle {
        gap: 1rem;
    }

    .auth-social-btn-circle {
        width: 50px;
        height: 50px;
    }

    .auth-social-btn-circle svg {
        width: 20px;
        height: 20px;
    }

    .policy-modal-overlay {
        padding: 1rem;
    }

    .policy-modal {
        max-height: calc(100vh - 2rem);
        padding: 2rem 1.5rem;
    }

    .policy-scroll {
        max-height: 60vh;
    }

    .auth-top-star,
    .auth-bottom-star {
        padding: 0.25rem 0;
    }

    .star-icon {
        width: 18px;
        height: 18px;
    }

    .auth-header-icons {
        top: 1rem;
        right: 1rem;
    }

    .auth-icon-btn {
        width: 45px;
        height: 45px;
    }

    .auth-icon {
        width: 22px;
        height: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/authPage/authPage.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,6BAA6B;;IAE7B,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,sBAAsB;IACtB,2CAA2C;IAC3C,0CAA0C;IAC1C,qBAAqB;IACrB,6BAA6B;IAC7B,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,2CAA2C;IAC3C,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;;IAGI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,0DAA0D;IAC1D,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,4DAA4D;IAC5D,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,UAAU;IACV,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI,SAAO;IACP,WAAW;IACX,sHAAsH;AAC1H;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;IAEI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,4DAA4D;IAC5D,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,mCAAmC;AACnC;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;IAC/B,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4DAA4D;IAC5D,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;QACb,kCAAkC;QAClC,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;;QAEI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;QACxB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".auth-page {\r\n    background-color: transparent;\r\n    min-height: 100vh;\r\n    height: auto;\r\n    display: flex;\r\n    margin: 0;\r\n    width: 100%;\r\n    padding: 2rem;\r\n    padding-top: 5rem;\r\n    padding-bottom: 3rem;\r\n    position: relative;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    -webkit-overflow-scrolling: touch;\r\n    /* Smooth momentum scrolling on iOS */\r\n}\r\n\r\n.auth-header-icons {\r\n    position: absolute;\r\n    top: 1.5rem;\r\n    left: 1.5rem;\r\n    display: flex;\r\n    gap: 1rem;\r\n    z-index: 100;\r\n}\r\n\r\n.auth-container {\r\n    top: 3rem;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    height: 90%;\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 50px;\r\n    padding: 2.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    margin: auto;\r\n}\r\n\r\n/* 使用伪元素创建带圆角的渐变边框 */\r\n.auth-container::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 50px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.auth-top-star,\r\n.auth-bottom-star {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0.75rem 0;\r\n}\r\n\r\n.star-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n    object-fit: contain;\r\n}\r\n\r\n.auth-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.auth-main-title {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 2rem;\r\n    font-weight: 600;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0 0 0.5rem 0;\r\n    letter-spacing: 0.1em;\r\n    text-transform: uppercase;\r\n    text-shadow: 0 0 30px rgba(213, 190, 155, 1);\r\n}\r\n\r\n.auth-subtitle {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.95rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0 0 2rem 0;\r\n    letter-spacing: 0.05em;\r\n    font-weight: 400;\r\n}\r\n\r\n.auth-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.2rem;\r\n    width: 100%;\r\n}\r\n\r\n.form-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n    gap: 0.5rem;\r\n    position: relative;\r\n}\r\n\r\n.form-label {\r\n    font-family: 'Urbanist-Regular';\r\n    font-size: 1.2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n\r\n    text-align: left;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.password-input-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.email-input-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    display: flex;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.email-input {\r\n    flex: 1;\r\n}\r\n\r\n.send-code-btn {\r\n    padding: 0.9rem 1.2rem;\r\n    background-color: rgba(213, 190, 155, 0.15);\r\n    border: 1px solid rgba(213, 190, 155, 0.5);\r\n    border-radius: 1000px;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    font-weight: 500;\r\n    letter-spacing: 0.05em;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.send-code-btn:hover:not(:disabled) {\r\n    background-color: rgba(213, 190, 155, 0.25);\r\n    border-color: rgba(213, 190, 155, 0.7);\r\n}\r\n\r\n.send-code-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 0.9rem 1rem;\r\n    background-color: rgba(208, 181, 137, 0.35);\r\n    border: none;\r\n    border-radius: 1000px;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'Urbanist-Regular';\r\n    font-size: 1rem;\r\n    letter-spacing: 0.05em;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    isolation: isolate;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.password-input {\r\n    padding-right: 3rem;\r\n}\r\n\r\n/* 使用伪元素创建输入框的渐变边框（0.5px 边框，带圆角） */\r\n.form-input::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 1000px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.form-input::placeholder {\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.form-input:focus {\r\n    outline: none;\r\n}\r\n\r\n/* Date and Time input specific fixes for iOS */\r\ninput[type=\"date\"].form-input,\r\ninput[type=\"time\"].form-input {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    min-height: 48px;\r\n    max-width: 100%;\r\n}\r\n\r\ninput[type=\"date\"].form-input::-webkit-calendar-picker-indicator,\r\ninput[type=\"time\"].form-input::-webkit-calendar-picker-indicator {\r\n    filter: invert(0.8) sepia(1) saturate(2) hue-rotate(10deg);\r\n    cursor: pointer;\r\n}\r\n\r\n.password-toggle {\r\n    position: absolute;\r\n    right: 1rem;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    color: rgba(213, 190, 155, 1);\r\n    cursor: pointer;\r\n    padding: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.3s ease;\r\n    z-index: 10;\r\n}\r\n\r\n.password-toggle:hover {\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.password-toggle svg {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n.auth-submit-btn,\r\n.auth-social-btn {\r\n    width: 100%;\r\n    padding: 1rem 2rem;\r\n    background-color: #000000;\r\n    border: none;\r\n    border-radius: 1000px;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.15em;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    text-transform: uppercase;\r\n    position: relative;\r\n    isolation: isolate;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.auth-social-btn {\r\n    padding: 0.75rem 1rem;\r\n    font-size: 0.9rem;\r\n    flex: 1;\r\n    white-space: nowrap;\r\n}\r\n\r\n.auth-social-buttons {\r\n    display: flex;\r\n    gap: 0.75rem;\r\n    width: 100%;\r\n}\r\n\r\n.auth-social-buttons-circle {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n    width: 100%;\r\n}\r\n\r\n.auth-social-btn-circle {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n    background-color: #000000;\r\n    border: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 0;\r\n    position: relative;\r\n    isolation: isolate;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n/* 使用伪元素创建圆形按钮的渐变边框 */\r\n.auth-social-btn-circle::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 50%;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.auth-social-btn-circle:hover {\r\n    transform: scale(1.1);\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.auth-social-btn-circle:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.auth-social-btn-circle svg {\r\n    width: 24px;\r\n    height: 24px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.auth-or-text {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    text-align: center;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.form-checkbox-group {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 0.75rem;\r\n    width: 100%;\r\n    margin: 1rem 0;\r\n}\r\n\r\n.auth-checkbox {\r\n    width: 18px;\r\n    height: 18px;\r\n    margin-top: 2px;\r\n    border-radius: 100%;\r\n    cursor: pointer;\r\n    accent-color: rgba(213, 190, 155, 1);\r\n    flex-shrink: 0;\r\n}\r\n\r\n.auth-checkbox-label {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    line-height: 1.5;\r\n    cursor: pointer;\r\n    flex: 1;\r\n}\r\n\r\n.auth-link-inline {\r\n    background: none;\r\n    border: none;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.85rem;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.auth-link-inline:hover {\r\n    color: rgba(213, 190, 155, 0.8);\r\n}\r\n\r\n.auth-divider {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    margin: 2rem\r\n}\r\n\r\n.divider-line {\r\n    flex: 1;\r\n    height: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n}\r\n\r\n.divider-star {\r\n    width: 20px;\r\n    height: 20px;\r\n    object-fit: contain;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* 使用伪元素创建按钮的渐变边框 */\r\n.auth-submit-btn::before,\r\n.auth-social-btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 1000px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.auth-submit-btn:hover,\r\n.auth-social-btn:hover {\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.auth-submit-btn:active,\r\n.auth-social-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n.auth-social-btn svg {\r\n    width: 20px;\r\n    height: 20px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.auth-footer-link {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.9rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    margin: 0;\r\n    text-align: center;\r\n}\r\n\r\n.auth-link {\r\n    background: none;\r\n    border: none;\r\n    color: rgba(213, 190, 155, 1);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.9rem;\r\n    letter-spacing: 0.05em;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    transition: all 0.3s ease;\r\n    padding: 0;\r\n    margin-left: 0.5rem;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.auth-link:hover {\r\n    color: rgba(213, 190, 155, 1);\r\n    text-decoration: underline;\r\n}\r\n\r\n.auth-icon-btn {\r\n    background-color: transparent;\r\n    width: 50px;\r\n    height: 50px;\r\n    border: none;\r\n    /* Add this back */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 0;\r\n    position: relative;\r\n    isolation: isolate;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n/* Hide the border pseudo-element */\r\n.auth-icon-btn::before {\r\n    display: none;\r\n}\r\n\r\n.auth-icon-btn:hover {\r\n    transform: scale(1.1);\r\n    background-color: transparent;\r\n    /* Remove hover background */\r\n    color: rgba(213, 190, 155, 0.8);\r\n    /* Optional: add subtle color change on hover */\r\n}\r\n\r\n.auth-icon-btn:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.policy-modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(5, 3, 14, 0.85);\r\n    backdrop-filter: blur(8px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 2rem;\r\n    z-index: 200;\r\n    overflow-y: auto;\r\n}\r\n\r\n.policy-modal {\r\n    position: relative;\r\n    width: min(960px, 100%);\r\n    max-height: calc(100vh - 4rem);\r\n    background: rgba(0, 0, 0, 0.85);\r\n    border-radius: 36px;\r\n    padding: 2.5rem 2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.policy-modal::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 36px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: 0;\r\n}\r\n\r\n.policy-modal>* {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.policy-close-btn {\r\n    position: absolute;\r\n    top: 1.2rem;\r\n    right: 1.2rem;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    border: none;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    color: rgba(213, 190, 155, 1);\r\n    font-size: 1.5rem;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.policy-close-btn:hover {\r\n    background: rgba(213, 190, 155, 0.15);\r\n}\r\n\r\n.policy-label {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.3em;\r\n    font-size: 0.8rem;\r\n    color: rgba(213, 190, 155, 0.8);\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.policy-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.policy-star {\r\n    font-size: 1.2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.policy-title {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1.8rem;\r\n    letter-spacing: 0.25em;\r\n    margin: 0;\r\n}\r\n\r\n.policy-subtitle {\r\n    text-align: center;\r\n    margin: 0.5rem 0 1.5rem 0;\r\n    font-size: 0.9rem;\r\n    letter-spacing: 0.2em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.policy-scroll {\r\n    max-height: 55vh;\r\n    overflow-y: auto;\r\n    padding-right: 1rem;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.policy-section {\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.policy-section h3 {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1.1rem;\r\n    letter-spacing: 0.15em;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.policy-section ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.4rem;\r\n    font-size: 0.9rem;\r\n    line-height: 1.6;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.policy-divider {\r\n    text-align: center;\r\n    color: rgba(213, 190, 155, 0.6);\r\n    margin-top: 1rem;\r\n}\r\n\r\n.policy-scroll::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.policy-scroll::-webkit-scrollbar-track {\r\n    background: rgba(255, 255, 255, 0.05);\r\n    border-radius: 999px;\r\n}\r\n\r\n.policy-scroll::-webkit-scrollbar-thumb {\r\n    background: rgba(213, 190, 155, 0.5);\r\n    border-radius: 999px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .auth-page {\r\n        padding: 1rem;\r\n        /* align-items 由 margin: auto 处理 */\r\n        padding-top: 4rem;\r\n        padding-bottom: 3rem;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .auth-container {\r\n        padding: 2rem 1.5rem;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .auth-main-title {\r\n        font-size: 1.8rem;\r\n    }\r\n\r\n    .auth-subtitle {\r\n        font-size: 0.9rem;\r\n        margin-bottom: 1.5rem;\r\n    }\r\n\r\n    .auth-submit-btn,\r\n    .auth-social-btn {\r\n        padding: 0.9rem 1.5rem;\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .auth-top-star,\r\n    .auth-bottom-star {\r\n        padding: 0.5rem 0;\r\n    }\r\n\r\n    .auth-form {\r\n        gap: 1rem;\r\n    }\r\n\r\n    .form-group {\r\n        gap: 0.4rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .auth-page {\r\n        padding: 0.5rem;\r\n        padding-top: 3.5rem;\r\n        padding-bottom: 2.5rem;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .auth-container {\r\n        padding: 1.5rem 1rem;\r\n        border-radius: 30px;\r\n    }\r\n\r\n    .auth-container::before {\r\n        border-radius: 30px;\r\n    }\r\n\r\n    .auth-main-title {\r\n        font-size: 1.4rem;\r\n        margin-bottom: 0.25rem;\r\n    }\r\n\r\n    .auth-subtitle {\r\n        font-size: 0.8rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .auth-form {\r\n        gap: 0.8rem;\r\n    }\r\n\r\n    .form-input {\r\n        padding: 0.75rem 0.85rem;\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .form-label {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .auth-submit-btn,\r\n    .auth-social-btn {\r\n        padding: 0.75rem 1rem;\r\n        font-size: 0.85rem;\r\n    }\r\n\r\n    .form-checkbox-group {\r\n        margin: 0.6rem 0;\r\n        gap: 0.5rem;\r\n    }\r\n\r\n    .auth-checkbox-label {\r\n        font-size: 0.75rem;\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .auth-link-inline {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .auth-divider {\r\n        margin: 0.8rem 0;\r\n    }\r\n\r\n    .auth-or-text {\r\n        font-size: 0.8rem;\r\n        margin-bottom: 0.8rem;\r\n    }\r\n\r\n    .auth-social-buttons-circle {\r\n        gap: 1rem;\r\n    }\r\n\r\n    .auth-social-btn-circle {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n\r\n    .auth-social-btn-circle svg {\r\n        width: 20px;\r\n        height: 20px;\r\n    }\r\n\r\n    .policy-modal-overlay {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .policy-modal {\r\n        max-height: calc(100vh - 2rem);\r\n        padding: 2rem 1.5rem;\r\n    }\r\n\r\n    .policy-scroll {\r\n        max-height: 60vh;\r\n    }\r\n\r\n    .auth-top-star,\r\n    .auth-bottom-star {\r\n        padding: 0.25rem 0;\r\n    }\r\n\r\n    .star-icon {\r\n        width: 18px;\r\n        height: 18px;\r\n    }\r\n\r\n    .auth-header-icons {\r\n        top: 1rem;\r\n        right: 1rem;\r\n    }\r\n\r\n    .auth-icon-btn {\r\n        width: 45px;\r\n        height: 45px;\r\n    }\r\n\r\n    .auth-icon {\r\n        width: 22px;\r\n        height: 22px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
